/**
 * 請求データ
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/admin-types'

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/invoices`

const invoice = {
  namespaced: true,
  state: {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      contractor_name: null,
      tenant_name: null,
      invoice_start_date: null,
      invoice_end_date: null,
      id: null,
      expence_id: null,
    },
  },
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    index ({ dispatch, commit, state }, { contractor_name, tenant_name, invoice_start_date, invoice_end_date, id, expence_id, page, format }) {
      let api_path
      if (format === 'csv') {
        api_path = `${API_PATH}.csv`
      } else {
        api_path = `${API_PATH}`
      }
      dispatch('saveCondition', {
        contractor_name: contractor_name,
        tenant_name: tenant_name,
        invoice_start_date: invoice_start_date,
        invoice_end_date: invoice_end_date
      })
      const params = { 
        contractor_name: state.condition.contractor_name,
        tenant_name: state.condition.tenant_name,
        invoice_start_date: state.condition.invoice_start_date,
        invoice_end_date: state.condition.invoice_end_date,
        id: id,
        expence_id: expence_id,
        page: page 
      }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          if ((format != 'csv')) {
            let content = data.content
            commit(types.ADMIN_INVOICE, { content })
            resolve(data.content)
          } else {
            resolve(data)
          }     
        })
      })
    },
    saveCondition ({ commit, state }, { contractor_name, tenant_name, invoice_start_date, invoice_end_date}) {
      const _contractor_name = (contractor_name !== undefined) ? contractor_name : state.condition.contractor_name
      const _tenant_name = (tenant_name !== undefined) ? tenant_name : state.condition.tenant_name
      const _invoice_start_date = (invoice_start_date !== undefined) ? invoice_start_date : state.condition.invoice_start_date
      const _invoice_end_date = (invoice_end_date !== undefined) ? invoice_end_date : state.condition.invoice_end_date
      const params = { 
        contractor_name: _contractor_name,
        tenant_name: _tenant_name,
        invoice_start_date: _invoice_start_date,
        invoice_end_date: _invoice_end_date
      }
      commit(types.ADMIN_INVOICE_CONDITION, { params })
    },
  },   
  mutations: {
    [types.ADMIN_INVOICE] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.ADMIN_INVOICE_CONDITION] (state, { params }) {
      state.condition.contractor_name = params.contractor_name,
      state.condition.tenant_name = params.tenant_name,
      state.condition.invoice_start_date = params.invoice_start_date,
      state.condition.invoice_end_date = params.invoice_end_date
    }
  }, 
}

export default invoice
